/* eslint-disable max-len */
import { faEye, faEyeSlash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, CircularProgress, FormControlLabel, Grid, Switch, TextField } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import LocalizedText, { localize } from 'commons/LocalizedText/LocalizedText';
import { useUserInfo } from 'hook/UseUserInfo';
import React, { useEffect, useState } from 'react';
import { NoteStatus } from 'utils/constants/noteStatus';
import { isEcc } from 'utils/constants/roles';

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 'bold'
  },
  isVisibleSwitch: {
    "& .MuiSwitch-track": {
      backgroundColor: `${theme.palette.text.modifiedLight} !important`
    }
  },
  controls: {
    marginTop: '40px'
  },
  button: {
    minWidth: '150px',
    color: 'white'
  },
  saveButton: {
    backgroundColor: theme.palette.text.modified,
    '&:hover': {
      backgroundColor: theme.palette.text.modifiedLight
    }
  },
  disabledSaveButton: {
    backgroundColor: theme.palette.text.modifiedLight
  },
  cancelButton: {
    backgroundColor: theme.palette.text.disabled,
    '&:hover': {
      backgroundColor: theme.palette.text.disabledLight
    }
  }
}));

const NoteEdition = ({ note = null, handleSaveNote, setNoteEditionMode, isLoadingNote }) => {
  const classes = useStyles();
  const theme = useTheme();
  const { role } = useUserInfo();
  const [newNote, setNewNote] = useState(note ?
    {...note, isVisible: note.status.id === NoteStatus.PUBLIC.id}
    :
    {isVisible: true});
  const [canSendNote, setCanSendNote] = useState(false);

  const handleNoteChange = (value, field) => {
    const noteTmp = {...newNote};
    noteTmp[field] = value;
    setNewNote(noteTmp);
  }

  useEffect(() => {
    if(
      (!!newNote.title)
      &&
      (!!newNote.content)
    ){
      setCanSendNote(true);
    }else{
      setCanSendNote(false);
    }
  }, [newNote])

  const handleCancel = () => {
    setNoteEditionMode(false);
    setNewNote(null);
  }

  const handleSave = () => {
    handleSaveNote(newNote);
  }

  return (
    <Grid item style={{alignSelf: "center", marginTop: '15px'}}>
      <Grid container direction='column' spacing={2}>
        <Grid item>
          <Grid container direction='column' spacing={1}>
            <Grid item>
              <LocalizedText className={classes.title}>title</LocalizedText>
            </Grid>
            <Grid item>
              <TextField
                multiline={false}
                onChange={e => handleNoteChange(e.target.value, 'title')}
                style={{minWidth: '500px'}}
                value={newNote.title || ''}
                variant='outlined'
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction='column' spacing={1}>
            <Grid item>
              <LocalizedText className={classes.title}>description</LocalizedText>
            </Grid>
            <Grid item>
              <TextField
                minRows={10}
                multiline={true}
                onChange={e => handleNoteChange(e.target.value, 'content')}
                style={{minWidth: '500px'}}
                value={newNote.content || ''}
                variant='outlined'
              />
            </Grid>
          </Grid>
        </Grid>
        {isEcc(role) &&
          <Grid item>
            <FormControlLabel
              control={
                <Switch
                  checked={newNote.isVisible}
                  checkedIcon={<FontAwesomeIcon icon={faEye} style={{fontSize: '20px'}}/>}
                  className={classes.isVisibleSwitch}
                  icon={<FontAwesomeIcon icon={faEyeSlash} style={{fontSize: '20px'}}/>}
                  onChange={e => handleNoteChange(e.target.checked, 'isVisible')}
                  style={{color: theme.palette.text.modified}}
                />
              }
              label={localize('noteVisibility')}
            />
          </Grid>
        }
        <Grid className={classes.controls} item>
          {isLoadingNote ?
            <CircularProgress style={{marginLeft:"50px"}}/>
            :
            <Grid container spacing={1}>
              <Grid item>
                <Button
                  className={`${classes.button} ${canSendNote ? classes.saveButton : classes.disabledSaveButton}`}
                  disabled={!canSendNote}
                  onClick={handleSave}
                >
                  {localize('save')}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  className={`${classes.button} ${classes.cancelButton}`}
                  onClick={handleCancel}
                >
                  {localize('cancel')}
                </Button>
              </Grid>
            </Grid>
          }
        </Grid>
      </Grid>
    </Grid>
  );
};

export default NoteEdition;